
<app-change-password
    [componentUsing]="componentUsing"
    [emailAddress]="emailAddress"
    (submitChange)="onPasswordSubmitChange($event)">
</app-change-password>
